<!-- notification section -->
<div
  class="my-tables-container ml-25 mr-25"
  *ngIf="allNotification.length !== 0 && noItems == false"
>
  <!-- server card container div -->
  <div class="server-cards-container-grid">
    <!-- server card div -->
    <div class="server-card" *ngFor="let notification of allNotification">
      <div
        class="card_upper_container"
        (click)="notification.collect_cash ? openModal(notification) : ''"
      >
        <div class="server-card-top">
          <div class="server-card-top-lc">
            <div class="server-card-tno">
              <div>{{ notification.table_no }}</div>
            </div>
          </div>
          <div class="server-card-top-rc">
            <div class="text-username-notification">
              {{ notification.username }}
            </div>
            <div class="floor-paid-row">
              <img
                [src]="images.ASPECT_RATIO_MATERIAL"
                class="img-20 mr-10"
                style="vertical-align: middle"
                alt="aspect-ratio"
              />
              <div class="text-floorname">
                {{ notification.floor_name }}
              </div>
            </div>
          </div>
          <div class="server-card-top-last">
            <img [src]="images.TIMER" alt="timer" />
            <p class="timer">{{ notification.time_text }}</p>
          </div>
        </div>

        <div
          class="message-area-cash-collect"
          *ngIf="notification.collect_cash"
        >
          <div>
            <img [src]="images.CASH_TABLE_SERVICE" alt="cash-table-icon" />
          </div>
          <div style="margin-left: 10px">
            <div class="cash_total_text">
              <!-- {{Currency}} 1000 -->
            </div>
            <div class="collect_cash_text">
              {{ 'SETTLE_BILL.COLLECT_CASH' | fallbackTranslate }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="server-card-bottom c-served text-color-basic"
        (click)="openModal(notification)"
        style="cursor: pointer"
        *ngIf="notification.collect_cash"
      >
        {{ 'SETTLE_BILL.VIEW_DETAILS' | fallbackTranslate }}
      </div>
    </div>
    <!-- ends server card div -->
  </div>

  <!-- ends server card container div -->
</div>
<!-- notification section  -->
<div *ngIf="noItems">
  <p class="no-request text-center">
    {{ 'NO_NEW_REQUEST' | fallbackTranslate }}
  </p>
</div>
